<template>
  <ol class="list-decimal ml-9">
    <li v-for="item in items" :key="item">{{item}}</li>
  </ol>
</template>

<script>
export default {
  name: "numberedList",
  props: ['items']
}
</script>

<style scoped>

</style>